<template>
  <el-dialog
    class="dialog-container"
    :title="info.title"
    :visible.sync="visible"
    width="80%"
    append-to-body
    :before-close="() => (visible = false)"
  >
    <div class="video-player">
      <video v-if="isOssVideo" ref="videoRef" :src="info.url" autoplay controls></video>
      <iframe
        v-else
        :src="info.url"
        width="100%"
        height="600"
        scrolling="no"
        border="0"
        frameborder="no"
        framespacing="0"
        allowfullscreen="true"
      />
    </div>
  </el-dialog>
</template>

<script setup>
import { services } from '@/service';
import larkplayer from 'larkplayer';
import 'larkplayer-ui';

import { ref, computed, onMounted } from 'vue';

const player = ref(null);
const videoRef = ref(null);
const emit = defineEmits(['update:show']);

const props = defineProps({
  info: {
    type: Object,
    required: true
  },
  show: {
    type: Boolean,
    default: false
  }
});

const visible = computed({
  get() {
    return props.show;
  },
  set(val) {
    emit('update:show', val);
  }
});

const isOssVideo = props.info.url.indexOf('//player.bilibili.com') === -1;

onMounted(() => {
  if (isOssVideo) {
    player.value = larkplayer(videoRef.value, {
      width: '100%'
    });
  }

  let operateName = '视频点击';
  operateName = `${operateName}-${props.info.title}`;
  services.logger.handleLog({ operateName });
});
</script>

<style lang="scss" scoped>
.dialog-container {
  display: flex;
  align-items: center;

  ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 0;
    }
  }
}
.video-player {
  width: 100%;
  background-color: #000;
  & > video {
    display: block;
    width: 100%;
  }
}
</style>
